var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultImageBlockNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 179296",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6641",
    style: {
      fill: "#fff",
      stroke: "#e1e1e1",
      strokeDasharray: "2 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v39H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146607",
    transform: "translate(4 4)",
    style: {
      fill: "#e1e1e1"
    },
    d: "M0 0h166v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29614",
    d: "M2.385 1h9.231A1.385 1.385 0 0 1 13 2.385v9.231A1.385 1.385 0 0 1 11.615 13h-9.23A1.385 1.385 0 0 1 1 11.615v-9.23A1.385 1.385 0 0 1 2.385 1zm0 .923a.462.462 0 0 0-.462.462V7.8l1.553-1.555a.415.415 0 0 1 .6.01L7.345 9.76l2.592-2.592a.415.415 0 0 1 .587 0l1.553 1.552V2.385a.462.462 0 0 0-.462-.462zm-.462 9.692V8.972l1.836-1.836 3.27 3.5 1.3 1.438H2.385a.462.462 0 0 1-.462-.459zm9.692.462H9.451l-1.543-1.7 2.323-2.323L12.077 9.9v1.72a.462.462 0 0 1-.462.457zm-5.4-6.923A.785.785 0 1 1 7 5.939a.785.785 0 0 1-.785-.785zM7 3.538a1.616 1.616 0 1 0 1.616 1.616A1.616 1.616 0 0 0 7 3.538z",
    transform: "translate(80 13)",
    style: {
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageBlockNewIcon);
export default __webpack_public_path__ + "static/media/default_image_block_new_icon.b877a912cc41596e9a60bb6895d6efab.svg";
export { ForwardRef as ReactComponent };